import { ReactNode } from 'react';

import { css } from '@compiled/react';

import DarkConfluenceBackground from '../assets/confluence-background-dark';
import LightConfluenceBackground from '../assets/confluence-background-light';

export type ConfluenceBackgroundProps = {
	readonly allowDarkMode?: boolean;
};

export const ConfluenceBackground = ({ allowDarkMode }: ConfluenceBackgroundProps): ReactNode => {
	return (
		<div css={backgroundStyles}>
			{allowDarkMode && (
				<div css={prefersLightHideDark}>
					<DarkConfluenceBackground />
				</div>
			)}
			<div css={[allowDarkMode && prefersDarkHideLight]}>
				<LightConfluenceBackground />
			</div>
		</div>
	);
};

const backgroundStyles = css({
	height: '100%',
	position: 'fixed',
	insetBlockStart: 0,
	insetInlineStart: 0,
	insetInlineEnd: 0,
	insetBlockEnd: 0,
	overflow: 'hidden',
});

const prefersLightHideDark = css({
	'@media (prefers-color-scheme: light)': {
		display: 'none',
	},
});

const prefersDarkHideLight = css({
	'@media (prefers-color-scheme: dark)': {
		display: 'none',
	},
});
